import {
	GROUP_BY_ASSIGNEE,
	GROUP_BY_CATEGORY,
	GROUP_BY_PRIORITY,
	GROUP_BY_STATUS,
} from '@atlassian/jira-business-constants';
import { useProject } from '@atlassian/jira-business-entity-project-hook';
import type { Group } from '../../../common/types';

export const useHasDragPermission = (groupType: Group['type']) => {
	const {
		permissions: {
			editIssues: hasEditIssuesPermission,
			scheduleIssues: hasScheduleIssuesPermission,
			transitionIssues: hasTransitionIssuesPermission,
		},
	} = useProject();

	const hasRankPermission = hasEditIssuesPermission && hasScheduleIssuesPermission;

	switch (groupType) {
		/*
		 * TODO: This should be updated to check for the correct permission.
		 * There is a specific permission to update an issue's assignee which
		 * maps to the "Assign any issue" checkbox in the project access page.
		 * See: https://jbusiness.atlassian.net/browse/FUN-1216
		 */
		case GROUP_BY_ASSIGNEE:
		case GROUP_BY_CATEGORY:
		case GROUP_BY_PRIORITY:
			return hasEditIssuesPermission;
		case GROUP_BY_STATUS:
			return hasRankPermission || hasTransitionIssuesPermission;
		default: {
			const exhaustiveCheck: never = groupType;
			throw new Error(`Unexpected groupBy value: ${exhaustiveCheck}`);
		}
	}
};
